// Single source of truth for "the public origin this build points at."
//
// Was hardcoded in five different files across the frontend (api,
// supabase, capacitor, BrandingContext, MediaImage) — every time a
// build rolled cross-repo (dev → prod, or into mobiletexting) one of
// them silently kept the wrong hostname. Centralized here so the value
// is baked in exactly once at build time via REACT_APP_PUBLIC_HOST.
//
// Precedence:
//   1. REACT_APP_PUBLIC_HOST at build time (CRA DefinePlugin replaces
//      the expression with a string literal — there's no runtime
//      `process` lookup after webpack is done)
//   2. If running inside Capacitor's WKWebView (origin starts with
//      `capacitor://`), fall back to the production host hardcoded
//      below. This is defense-in-depth: #1 should always win on a
//      proper build, but if an older OTA bundle or stray build ever
//      landed without the env var set, winOrigin would be
//      `capacitor://localhost` and the Supabase client would throw at
//      startup — React would never mount, white screen.
//   3. window.location.origin (web runtime — the page's own origin)
//   4. Empty string (SSR / no window; callers should tolerate this)
//
// IMPORTANT: do NOT wrap process.env access in `typeof process !==
// 'undefined' && …`. Capacitor WKWebView doesn't define a global
// `process`, so that guard evaluates false at runtime and short-
// circuits the entire expression BEFORE the CRA-baked literal is
// reached — this was the root cause of the Capacitor OTA white-screen
// bug. CRA DefinePlugin replaces `process.env.REACT_APP_PUBLIC_HOST`
// at build time, so by the time it runs there's no actual `process`
// reference anyway.
const CAPACITOR_FALLBACK_HOST = 'https://texting.snapcom.com';

const envHost = (process.env.REACT_APP_PUBLIC_HOST || '').trim();
const winOrigin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
const isCapacitorOrigin = winOrigin.startsWith('capacitor://');

export const PUBLIC_HOST = (
  envHost ||
  (isCapacitorOrigin ? CAPACITOR_FALLBACK_HOST : '') ||
  winOrigin ||
  ''
).replace(/\/+$/, '');

export default PUBLIC_HOST;
